import React from "react";

export default function VisaCardMore() {
  return (
    <div
      bgcolor="#FFFFFF"
      text="#000000"
      leftmargin="0"
      topmargin="0"
      marginwidth="0"
      marginheight="0"
    >
      <div>
        <img src="/images/verified-by-visa6450.jpg" width="300" height="170" />
      </div>
      <table width="550" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td valign="top" width="68">
            <div>
              <img src="/images/vbv_spacer.gif" width="1" height="87" />
            </div>
            <table width="68" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td>
                  <img src="/images/vbv_spacer.gif" width="68" height="61" />
                </td>
              </tr>
            </table>
          </td>
          <td width="13">
            <img src="/images/vbv_spacer.gif" width="13" height="1" />
          </td>
          <td>
            <div>
              <img
                src="/images/vbv_protect_your_visa_card.gif"
                width="164"
                height="14"
                vspace="10"
              />
            </div>
            <p class="serifbody">
              Verified by Visa is free to Visa cardholders and was developed to
              help prevent unauthorized use of Visa cards online.
            </p>
            <p class="serifbody">
              Verified by Visa protects Visa cards with personal passwords,
              giving cardholders reassurance that only they can use their Visa
              cards online.
            </p>
            <p class="serifbody">
              Once your card is activated, your card number will be recognized
              whenever it's used at participating online stores. A Verified by
              Visa window will automatically appear and your Visa card issuer
              will ask for your password. You'll enter your password to verify
              your identity and complete your purchase.
            </p>
            <p class="serifbody">
              At stores that aren't participating in Verified by Visa yet, your
              Visa card will continue to work as usual.
            </p>
          </td>
          <td width="35">
            <img src="/images/spacer.gif" width="35" height="1" />
          </td>
        </tr>
        <tr>
          <td>
            <img src="/images/vbv_spacer.gif" width="68" height="1" />
          </td>
          <td>
            <img src="/images/vbv_spacer.gif" width="13" height="1" />
          </td>
          <td align="center">
            <a href="https://verified.visa.com/aam/src/app/aam.aam">
              <img
                src="/images/vbv_activate_now.gif"
                width="171"
                height="39"
                border="0"
                vspace="20"
                alt="Click Here, Activate Now"
              />
            </a>
          </td>
          <td>
            <img src="/images/vbv_spacer.gif" width="35" height="1" />
          </td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td>
            <img src="/images/vbv_spacer.gif" width="20" height="1" />
          </td>
          <td>
            <img src="/images/VISA2.jpg" width="70" height="50" border="0" />
            &nbsp;
          </td>
          <td class="footer">
            &copy; Copyright 2003, Visa U.S.A. All rights reserved.
          </td>
        </tr>
      </table>
    </div>
  );
}
